import styled from 'styled-components';
import { Container } from '@mui/material';
import { FOOTER_NAVIGATION_BAR_HEIGHT } from '../../attrs/layout';

export const ContainerForm = styled(Container)`
  padding-bottom: ${FOOTER_NAVIGATION_BAR_HEIGHT + 20}px;
  @media (max-width: 768px) {
    padding-top: 2rem;
  }
  @media (max-width: 425px) {
    padding-top: 4rem;
  }
`;

export const PageHeaderTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
`;
